<div>
  <svg viewBox="0 0 1 1"></svg>
  <img loading="lazy" [src]="item?.imageUrl || 'assets/logos/link.svg'" />
</div>
